/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacySupplierAttribute from './pharmacy-supplier-attribute';
import PharmacySupplierAttributeDetail from './pharmacy-supplier-attribute-detail';
import PharmacySupplierAttributeUpdate from './pharmacy-supplier-attribute-update';
import PharmacySupplierAttributeDeleteDialog from './pharmacy-supplier-attribute-delete-dialog';

const PharmacySupplierAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacySupplierAttribute />} />
    <Route path="new" element={<PharmacySupplierAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacySupplierAttributeDetail />} />
      <Route path="edit" element={<PharmacySupplierAttributeUpdate />} />
      <Route path="delete" element={<PharmacySupplierAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacySupplierAttributeRoutes;
